<template><div><div v-if="show_options">
<tile-question-layout :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

</tile-question-layout>
</div></div></template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareDecorativeHandle from "../DesignerQuestionHardwareDecorativeHandle.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareDecorativeHandle
        ],
        computed: {
            show_options(){
                return this.filtered_option_list.length > 0;
            }
        },
    }
</script>
